<template>
  <div class="row synops">
    <div class="col-10 no-padding">
      <div class="company-title">{{ company_name }}</div>
      <div class="job-title">{{ title }}</div>
      <div class="date">
        <v-icon
          style="color: var(--icon-grey-scale-color); margin-right: 5px; margin-bottom: 2px;"
          size="18"
          >mdi-clock</v-icon
        ><span
          >Open date: <span class="published">{{ openDate }}</span></span
        >
      </div>
      <div class="date">
        <v-icon
          style="color: var(--icon-grey-scale-color); margin-right: 5px; margin-bottom: 2px;"
          size="18"
          >mdi-clock</v-icon
        ><span
          >Close date: <span class="closing">{{ closeDate }}</span></span
        >
      </div>
      <div
        style="padding-top: 0.5rem; color: var(--button-delete-color); text-align: left"
        v-if="reason"
      >
        *{{ reason }}
      </div>
    </div>
  </div>
</template>

<script>
import * as FILTER from "../../../filters";
import * as FUNCTIONS from "../../../globalFunctions";
export default {
  name: "job-synops",
  props: {
    job: Object,
    index: Number
  },
  data: function() {
    return {
      id: null,
      title: null,
      company_name: null,
      openDate: null,
      closeDate: null,
      compliance: false,
      reason: null
    };
  },
  methods: {
    changeStatus(action) {
      const self = this;
      if (action === 10) {
        alert("This job can not be approved now");
      } else {
        self.$emit("change-status", self.id, action, self.index);
      }
    }
  },
  mounted() {
    const self = this;
    if (self.job) {
      self.id = self.job.job_id;
      self.title = FILTER.FIRST_LETTER_CAPITAL(self.job.job_title);
      self.company_name = FILTER.FIRST_LETTER_CAPITAL(self.job.company_name);
      self.openDate = FUNCTIONS.MONTH_DATE_FORMAT(self.job.open_date);
      self.closeDate = FUNCTIONS.MONTH_DATE_FORMAT(self.job.close_date);
      self.compliance = self.job.compliance;
      if (!self.compliance) {
        self.reason = self.job.reason;
      }
    }
  }
};
</script>

<style scoped>
.synops {
  padding: 15px;
  cursor: pointer;
  border-bottom: 1px solid #eeeeee;
}
.company-title {
  font-size: 20px;
  text-align: left;
  color: #050505;
  font-weight: bold;
}
.job-title {
  font-size: 16px;
  text-align: left;
  color: #050505;
}
.date {
  font-size: 14px;
  text-align: left;
  color: #3d4249;
}
.published {
  color: #050505;
}
.closing {
  color: #050505;
}
.but {
  text-align: right;
  padding: 3rem 0 0 0;
}
</style>
